<div class="modal-window-container fx-cover fx-center-all" #container>
    <div class="modal-window-inner" #window>
        <iframe scrolling="no" #teamUserConfirmationFrame [src]="confirmationWindowUrl | safe" class="team-user-confirmation-window-iframe"></iframe>
    </div>
</div>